const ACCESS_TOKEN = 'IshEdu_ACCESS_TOKEN';
const REFRESH_TOKEN = 'IshEdu_REFRESH_TOKEN';
const IshEdu_User = 'IshEdu_User_Data';
const IshEdu_lang = 'IshEdu_lang';
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);

export const setAccessToken = (token) => {
    localStorage.setItem(ACCESS_TOKEN, token);
}

export const removeAccessToken = () => {
    localStorage.removeItem(ACCESS_TOKEN);
}

export const setRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN, token);
}

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);

export const removeRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN);
}

export function setUserData(data) {
    return localStorage.setItem(IshEdu_User, data);
}
export function getUserData() {
    return JSON.parse(localStorage.getItem(IshEdu_User))
}

export function setUserLang(lang) {
    return localStorage.setItem(IshEdu_lang, lang);
}
export function getUserLang(){
    return localStorage.getItem(IshEdu_lang)
}
export function removeUserLang(){
    return localStorage.removeItem(IshEdu_lang);
}
